module.exports = __webpack_public_path__ + "89bfc414a243300cf97227e768b28a93.png";